export default __webpack_public_path__ + "static/media/cp-ic-messages.64c54519.svg";